import { DateField, TextField, TimeField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TravelDirection, TravelSegmentFormValues } from "../../../../../shared/types/travelSegment";

export const emptyCarFormValues = (): TravelSegmentFormValues => ({
	id: Symbol("car"),
	type: "car",
	arrivalDate: null,
	arrivalTime: null,
	departureDate: null,
	departureTime: null,
	arrivalLocation: "",
	departureLocation: "",
	identifier: "",
	chargingStation: "",
	parkingSpot: "",
});

export const TravelSegmentCarFormFields: FC<{ direction: TravelDirection }> = ({ direction }) => {
	const { t } = useTranslation();

	return (
		<>
			<TextField name="identifier" label={t("License plate")} required />
			{direction === "arrival" && <DateField name="arrivalDate" label={t("Arrival date")} required />}
			{direction === "arrival" && <TimeField name="arrivalTime" label={t("Arrival time")} required />}
			<TextField name="arrivalLocation" label={t("Arrival location")} />
			{direction === "departure" && <DateField name="departureDate" label={t("Departure date")} required />}
			{direction === "departure" && <TimeField name="departureTime" label={t("Departure time")} required />}
			<TextField name="departureLocation" label={t("Departure location")} />
			<TextField name="parkingSpot" label={t("Parking spot")} />
			<TextField name="chargingStation" label={t("Charging station")} />
		</>
	);
};
